module.exports = __webpack_public_path__ + "media/01.6e5850b4.mp4";